import { ConfirmItemKeywordType, ConfirmStatus } from 'types/marketplace/confirmItem';
import { ContestOngoingFilterType } from 'types/marketplace/operation/contest';
import { FilterConfig, FilterValueType } from 'modules/utils/filterUtils';

/**
 * Confirm Item 필터 정의
 *
 * 새로운 필터를 추가하려면 여기에만 추가하면 됩니다.
 * 나머지는 filterUtils를 통해 자동으로 처리됩니다.
 *
 * ⚠️ 주의:
 * - 날짜 필터(dateFrom, dateTo, dateTerm)는 별도 DateForm으로 관리되므로 여기서 제외
 * - 페이지네이션(page, sort, limit)은 별도로 관리되므로 여기서 제외
 */
export const CONFIRM_ITEM_FILTERS: FilterConfig = {
  // 배열 타입 필터들
  statuses: {
    key: 'statuses',
    type: FilterValueType.NUMBER_ARRAY,
    defaultValue: [ConfirmStatus.PENDING, ConfirmStatus.PUBLISHED, ConfirmStatus.REJECTED],
  },
  salesTypes: {
    key: 'salesTypes',
    type: FilterValueType.NUMBER_ARRAY,
    defaultValue: [],
  },
  itemTypes: {
    key: 'itemTypes',
    type: FilterValueType.STRING_ARRAY,
    defaultValue: [],
  },
  softwares: {
    key: 'softwares',
    type: FilterValueType.NUMBER_ARRAY,
    defaultValue: [],
  },
  contestFilter: {
    key: 'contestFilter',
    type: FilterValueType.STRING_ARRAY,
    defaultValue: [String(ContestOngoingFilterType.NONE), String(ContestOngoingFilterType.CLOSED)],
  },
  convertingStatuses: {
    key: 'convertingStatuses',
    type: FilterValueType.NUMBER_ARRAY,
    defaultValue: [],
  },
  // 단일 값 필터들
  mdPick: {
    key: 'mdPick',
    type: FilterValueType.BOOLEAN,
    defaultValue: false,
  },
  curatorsPick: {
    key: 'curatorsPick',
    type: FilterValueType.BOOLEAN,
    defaultValue: false,
  },
  keyword: {
    key: 'keyword',
    type: FilterValueType.STRING,
    defaultValue: '',
    apiKey: 'searchKeyword',
  },
  keywordType: {
    key: 'keywordType',
    type: FilterValueType.NUMBER,
    defaultValue: ConfirmItemKeywordType.ItemName,
  },
};
